import { object } from 'valibot'

import { stringToNumber } from '@/libs/valibot'

export const ItemUnitParamsSchema = object({
  ItemUnitId: stringToNumber()
})
